import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PermissionInterface } from "../Types/Permission/PermissionInterface";
import { getAllPermissionsThunk } from "../Thunks/permissionThunks";

interface PermissionState {
    loadingPermission: boolean;
    permissions: PermissionInterface[];
    errorPermission: string | null;

}

const initialState : PermissionState = {
    loadingPermission: false,
    permissions: [],
    errorPermission: '',

}

const permissionSlice = createSlice ({
    name: 'permission',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getAllPermissionsThunk.rejected, (state, action) => {
                    state.loadingPermission = false;
                    state.errorPermission = action.error.message!;
                  })
                    .addCase(getAllPermissionsThunk.pending, state => {
                    state.loadingPermission = true;
                    state.errorPermission = null;
                  })
                  .addCase(getAllPermissionsThunk.fulfilled, (state, action: PayloadAction<PermissionInterface[]>) => {
                    state.loadingPermission = false;
                    
                    state.permissions = action.payload;
                  
                    
                  })
    }
})


export const {} = permissionSlice.actions
export default permissionSlice.reducer